var render, staticRenderFns
import script from "./horizontal_bar_chart.vue?vue&type=script&lang=js&"
export * from "./horizontal_bar_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284d3c10')) {
      api.createRecord('284d3c10', component.options)
    } else {
      api.reload('284d3c10', component.options)
    }
    
  }
}
component.options.__file = "src/components/chart/horizontal_bar_chart.vue"
export default component.exports